import { component } from 'picoapp';
import './component.scss';

class Product {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.el = el;
    // this.init();
  }

  init() {
    // console.log('product view');
  }
}

export default component((node, ctx) => {
  new Product(node, ctx);
});
